var map = {
	"./square/ac.svg": 1762,
	"./square/ad.svg": 1763,
	"./square/ae.svg": 1764,
	"./square/af.svg": 1765,
	"./square/ag.svg": 1766,
	"./square/ai.svg": 1767,
	"./square/al.svg": 1768,
	"./square/am.svg": 1769,
	"./square/ao.svg": 1770,
	"./square/aq.svg": 1771,
	"./square/ar.svg": 1772,
	"./square/as.svg": 1773,
	"./square/at.svg": 1774,
	"./square/au.svg": 1775,
	"./square/aw.svg": 1776,
	"./square/ax.svg": 1777,
	"./square/az.svg": 1778,
	"./square/ba.svg": 1779,
	"./square/bb.svg": 1780,
	"./square/bd.svg": 1781,
	"./square/be.svg": 1782,
	"./square/bf.svg": 1783,
	"./square/bg.svg": 1784,
	"./square/bh.svg": 1785,
	"./square/bi.svg": 1786,
	"./square/bj.svg": 1787,
	"./square/bl.svg": 1788,
	"./square/bm.svg": 1789,
	"./square/bn.svg": 1790,
	"./square/bo.svg": 1791,
	"./square/bq.svg": 1792,
	"./square/br.svg": 1793,
	"./square/bs.svg": 1794,
	"./square/bt.svg": 1795,
	"./square/bv.svg": 1796,
	"./square/bw.svg": 1797,
	"./square/by.svg": 1798,
	"./square/bz.svg": 1799,
	"./square/ca.svg": 1800,
	"./square/cc.svg": 1801,
	"./square/cd.svg": 1802,
	"./square/cefta.svg": 1803,
	"./square/cf.svg": 1804,
	"./square/cg.svg": 1805,
	"./square/ch.svg": 1806,
	"./square/ci.svg": 1807,
	"./square/ck.svg": 1808,
	"./square/cl.svg": 1809,
	"./square/cm.svg": 1810,
	"./square/cn.svg": 1811,
	"./square/co.svg": 1812,
	"./square/cp.svg": 1813,
	"./square/cr.svg": 1814,
	"./square/cu.svg": 1815,
	"./square/cv.svg": 1816,
	"./square/cw.svg": 1817,
	"./square/cx.svg": 1818,
	"./square/cy.svg": 1819,
	"./square/cz.svg": 1820,
	"./square/de.svg": 1821,
	"./square/dg.svg": 1822,
	"./square/dj.svg": 1823,
	"./square/dk.svg": 1824,
	"./square/dm.svg": 1825,
	"./square/do.svg": 1826,
	"./square/dz.svg": 1827,
	"./square/ea.svg": 1828,
	"./square/ec.svg": 1829,
	"./square/ee.svg": 1830,
	"./square/eg.svg": 1831,
	"./square/eh.svg": 1832,
	"./square/er.svg": 1833,
	"./square/es-ct.svg": 1834,
	"./square/es-ga.svg": 1835,
	"./square/es.svg": 1836,
	"./square/et.svg": 1837,
	"./square/eu.svg": 1838,
	"./square/fi.svg": 1839,
	"./square/fj.svg": 1840,
	"./square/fk.svg": 1841,
	"./square/fm.svg": 1842,
	"./square/fo.svg": 1843,
	"./square/fr.svg": 1844,
	"./square/ga.svg": 1845,
	"./square/gb-eng.svg": 1846,
	"./square/gb-nir.svg": 1847,
	"./square/gb-sct.svg": 1848,
	"./square/gb-wls.svg": 1849,
	"./square/gb.svg": 1850,
	"./square/gd.svg": 1851,
	"./square/ge.svg": 1852,
	"./square/gf.svg": 1853,
	"./square/gg.svg": 1854,
	"./square/gh.svg": 1855,
	"./square/gi.svg": 1856,
	"./square/gl.svg": 1857,
	"./square/gm.svg": 1858,
	"./square/gn.svg": 1859,
	"./square/gp.svg": 1860,
	"./square/gq.svg": 1861,
	"./square/gr.svg": 1862,
	"./square/gs.svg": 1863,
	"./square/gt.svg": 1864,
	"./square/gu.svg": 1865,
	"./square/gw.svg": 1866,
	"./square/gy.svg": 1867,
	"./square/hk.svg": 1868,
	"./square/hm.svg": 1869,
	"./square/hn.svg": 1870,
	"./square/hr.svg": 1871,
	"./square/ht.svg": 1872,
	"./square/hu.svg": 1873,
	"./square/ic.svg": 1874,
	"./square/id.svg": 1875,
	"./square/ie.svg": 1876,
	"./square/il.svg": 1877,
	"./square/im.svg": 1878,
	"./square/in.svg": 1879,
	"./square/io.svg": 1880,
	"./square/iq.svg": 1881,
	"./square/ir.svg": 1882,
	"./square/is.svg": 1883,
	"./square/it.svg": 1884,
	"./square/je.svg": 1885,
	"./square/jm.svg": 1886,
	"./square/jo.svg": 1887,
	"./square/jp.svg": 1888,
	"./square/ke.svg": 1889,
	"./square/kg.svg": 1890,
	"./square/kh.svg": 1891,
	"./square/ki.svg": 1892,
	"./square/km.svg": 1893,
	"./square/kn.svg": 1894,
	"./square/kp.svg": 1895,
	"./square/kr.svg": 1896,
	"./square/kw.svg": 1897,
	"./square/ky.svg": 1898,
	"./square/kz.svg": 1899,
	"./square/la.svg": 1900,
	"./square/lb.svg": 1901,
	"./square/lc.svg": 1902,
	"./square/li.svg": 1903,
	"./square/lk.svg": 1904,
	"./square/lr.svg": 1905,
	"./square/ls.svg": 1906,
	"./square/lt.svg": 1907,
	"./square/lu.svg": 1908,
	"./square/lv.svg": 1909,
	"./square/ly.svg": 1910,
	"./square/ma.svg": 1911,
	"./square/mc.svg": 1912,
	"./square/md.svg": 1913,
	"./square/me.svg": 1914,
	"./square/mf.svg": 1915,
	"./square/mg.svg": 1916,
	"./square/mh.svg": 1917,
	"./square/mk.svg": 1918,
	"./square/ml.svg": 1919,
	"./square/mm.svg": 1920,
	"./square/mn.svg": 1921,
	"./square/mo.svg": 1922,
	"./square/mp.svg": 1923,
	"./square/mq.svg": 1924,
	"./square/mr.svg": 1925,
	"./square/ms.svg": 1926,
	"./square/mt.svg": 1927,
	"./square/mu.svg": 1928,
	"./square/mv.svg": 1929,
	"./square/mw.svg": 1930,
	"./square/mx.svg": 1931,
	"./square/my.svg": 1932,
	"./square/mz.svg": 1933,
	"./square/na.svg": 1934,
	"./square/nc.svg": 1935,
	"./square/ne.svg": 1936,
	"./square/nf.svg": 1937,
	"./square/ng.svg": 1938,
	"./square/ni.svg": 1939,
	"./square/nl.svg": 1940,
	"./square/no.svg": 1941,
	"./square/np.svg": 1942,
	"./square/nr.svg": 1943,
	"./square/nu.svg": 1944,
	"./square/nz.svg": 1945,
	"./square/om.svg": 1946,
	"./square/pa.svg": 1947,
	"./square/pe.svg": 1948,
	"./square/pf.svg": 1949,
	"./square/pg.svg": 1950,
	"./square/ph.svg": 1951,
	"./square/pk.svg": 1952,
	"./square/pl.svg": 1953,
	"./square/pm.svg": 1954,
	"./square/pn.svg": 1955,
	"./square/pr.svg": 1956,
	"./square/ps.svg": 1957,
	"./square/pt.svg": 1958,
	"./square/pw.svg": 1959,
	"./square/py.svg": 1960,
	"./square/qa.svg": 1961,
	"./square/re.svg": 1962,
	"./square/ro.svg": 1963,
	"./square/rs.svg": 1964,
	"./square/ru.svg": 1965,
	"./square/rw.svg": 1966,
	"./square/sa.svg": 1967,
	"./square/sb.svg": 1968,
	"./square/sc.svg": 1969,
	"./square/sd.svg": 1970,
	"./square/se.svg": 1971,
	"./square/sg.svg": 1972,
	"./square/sh.svg": 1973,
	"./square/si.svg": 1974,
	"./square/sj.svg": 1975,
	"./square/sk.svg": 1976,
	"./square/sl.svg": 1977,
	"./square/sm.svg": 1978,
	"./square/sn.svg": 1979,
	"./square/so.svg": 1980,
	"./square/sr.svg": 1981,
	"./square/ss.svg": 1982,
	"./square/st.svg": 1983,
	"./square/sv.svg": 1984,
	"./square/sx.svg": 1985,
	"./square/sy.svg": 1986,
	"./square/sz.svg": 1987,
	"./square/ta.svg": 1988,
	"./square/tc.svg": 1989,
	"./square/td.svg": 1990,
	"./square/tf.svg": 1991,
	"./square/tg.svg": 1992,
	"./square/th.svg": 1993,
	"./square/tj.svg": 1994,
	"./square/tk.svg": 1995,
	"./square/tl.svg": 1996,
	"./square/tm.svg": 1997,
	"./square/tn.svg": 1998,
	"./square/to.svg": 1999,
	"./square/tr.svg": 2000,
	"./square/tt.svg": 2001,
	"./square/tv.svg": 2002,
	"./square/tw.svg": 2003,
	"./square/tz.svg": 2004,
	"./square/ua.svg": 2005,
	"./square/ug.svg": 2006,
	"./square/um.svg": 2007,
	"./square/un.svg": 2008,
	"./square/us.svg": 2009,
	"./square/uy.svg": 2010,
	"./square/uz.svg": 2011,
	"./square/va.svg": 2012,
	"./square/vc.svg": 2013,
	"./square/ve.svg": 2014,
	"./square/vg.svg": 2015,
	"./square/vi.svg": 2016,
	"./square/vn.svg": 2017,
	"./square/vu.svg": 2018,
	"./square/wf.svg": 2019,
	"./square/ws.svg": 2020,
	"./square/xk.svg": 2021,
	"./square/xx.svg": 2022,
	"./square/ye.svg": 2023,
	"./square/yt.svg": 2024,
	"./square/za.svg": 2025,
	"./square/zm.svg": 2026,
	"./square/zw.svg": 2027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1761;